/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CarrierRestrictionDirection } from "./CarrierRestrictionDirection";
import {
  CarrierRestrictionDirectionFromJSON,
  CarrierRestrictionDirectionFromJSONTyped,
  CarrierRestrictionDirectionToJSON,
  CarrierRestrictionDirectionToJSONTyped,
} from "./CarrierRestrictionDirection";

/**
 *
 * @export
 * @interface CarrierQuotingRestriction
 */
export interface CarrierQuotingRestriction {
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestriction
   */
  carrierQuotingRestrictionId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestriction
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestriction
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierQuotingRestriction
   */
  restrictionType?: string;
  /**
   *
   * @type {CarrierRestrictionDirection}
   * @memberof CarrierQuotingRestriction
   */
  direction?: CarrierRestrictionDirection;
  /**
   *
   * @type {Array<string>}
   * @memberof CarrierQuotingRestriction
   */
  postalCodes?: Array<string>;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierQuotingRestriction
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierQuotingRestriction
   */
  updatedAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the CarrierQuotingRestriction interface.
 */
export function instanceOfCarrierQuotingRestriction(
  value: object,
): value is CarrierQuotingRestriction {
  return true;
}

export function CarrierQuotingRestrictionFromJSON(
  json: any,
): CarrierQuotingRestriction {
  return CarrierQuotingRestrictionFromJSONTyped(json, false);
}

export function CarrierQuotingRestrictionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierQuotingRestriction {
  if (json == null) {
    return json;
  }
  return {
    carrierQuotingRestrictionId:
      json["carrierQuotingRestrictionId"] == null
        ? undefined
        : json["carrierQuotingRestrictionId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    name: json["name"] == null ? undefined : json["name"],
    restrictionType:
      json["restrictionType"] == null ? undefined : json["restrictionType"],
    direction:
      json["direction"] == null
        ? undefined
        : CarrierRestrictionDirectionFromJSON(json["direction"]),
    postalCodes: json["postalCodes"] == null ? undefined : json["postalCodes"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
  };
}

export function CarrierQuotingRestrictionToJSON(
  json: any,
): CarrierQuotingRestriction {
  return CarrierQuotingRestrictionToJSONTyped(json, false);
}

export function CarrierQuotingRestrictionToJSONTyped(
  value?: CarrierQuotingRestriction | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierQuotingRestrictionId: value["carrierQuotingRestrictionId"],
    carrierIdentifier: value["carrierIdentifier"],
    name: value["name"],
    restrictionType: value["restrictionType"],
    direction: CarrierRestrictionDirectionToJSON(value["direction"]),
    postalCodes: value["postalCodes"],
    createdAt: value["createdAt"],
    updatedAt: value["updatedAt"],
  };
}
